<!-- 医保读卡的公共弹窗 -->
<template>
  <el-dialog
    title="医保读卡-身份识别"
    :close-on-click-modal="false"
    :visible="visible"
    append-to-body
    width="80%"
    :show-close="false"
    @open="open"
    top="4vh"
  >
    <section v-loading="loading" element-loading-text="读卡加载中...">
      <medicare-read-card
        @read="receiveCardInfo"
        :loading.sync="loading"
        :visible="visible"
      />
      <el-descriptions title="" :column="4" v-if="result.baseinfo">
        <template slot="extra" v-if="items.length > 1">
          <el-select
            v-model="result"
            placeholder="请选择"
            value-key="baseinfo.psn_no"
            size="small"
            @change="handleChange"
          >
            <el-option
              :value="1"
              disabled
              style="width: 50rem; font-size: 15px"
              :gutter="12"
            >
              <el-row>
                <el-col :span="5">人员编号</el-col>
                <el-col :span="3">人员姓名</el-col>
                <el-col :span="5">证件号</el-col>
                <el-col :span="2">性别</el-col>
                <el-col :span="3">民族</el-col>
                <el-col :span="3">出生日期</el-col>
                <el-col :span="2">年龄</el-col>
              </el-row>
            </el-option>
            <el-option
              v-for="(item, index) in items"
              :key="index"
              :label="item.baseinfo.psn_name"
              :value="item"
            >
              <el-row>
                <el-col :span="5">{{ item.baseinfo.psn_no }}</el-col>
                <el-col :span="3">{{ item.baseinfo.psn_name }}</el-col>
                <el-col :span="5">{{ item.baseinfo.certno }}</el-col>
                <el-col :span="2">{{
                  item.baseinfo.gend | dictText("gend")
                }}</el-col>
                <el-col :span="3">{{
                  item.baseinfo.naty | dictText("naty")
                }}</el-col>
                <el-col :span="3">{{ item.baseinfo.brdy }}</el-col>
                <el-col :span="2">{{ item.baseinfo.age }}</el-col>
              </el-row>
            </el-option>
          </el-select>
        </template>
        <el-descriptions-item label="人员编号">{{
          result.baseinfo.psn_no
        }}</el-descriptions-item>
        <el-descriptions-item label="人员姓名">{{
          result.baseinfo.psn_name
        }}</el-descriptions-item>
        <el-descriptions-item label="证件类型">{{
          result.baseinfo.psn_cert_type | dictText("psn_cert_type")
        }}</el-descriptions-item>
        <el-descriptions-item label="证件号码">{{
          result.baseinfo.certno
        }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{
          result.baseinfo.gend | dictText("gend")
        }}</el-descriptions-item>
        <el-descriptions-item label="民族">{{
          result.baseinfo.naty | dictText("naty")
        }}</el-descriptions-item>
        <el-descriptions-item label="出生日期">{{
          result.baseinfo.brdy
        }}</el-descriptions-item>
        <el-descriptions-item label="年龄" v-if="result.baseinfo">{{
          result.baseinfo.age
        }}</el-descriptions-item>
      </el-descriptions>

      <div v-else style="width: 100%">
        <el-empty description="暂无数据，请先刷卡"></el-empty>
      </div>
      <div
        style="display: flex; border-top: 1px solid #eee"
        v-if="result.baseinfo"
      >
        <div style="flex: 1">
          <el-table
            v-if="result.insuinfo"
            ref="insuinfoTable"
            :data="result.insuinfo"
            @current-change="selectionChange"
            row-key="id"
            style="height: 15rem"
            border
            highlight-current-row
            @row-dblclick="select"
          >
            <el-table-column width="50" align="center" label="操作">
              <template slot-scope="scope">
                <el-radio v-model="selectionKey" :label="scope.$index"
                  ><span></span
                ></el-radio>
              </template>
            </el-table-column>
            <el-table-column
              label="余额"
              prop="balc"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column label="险种类型" prop="insutype" align="center">
              <template slot-scope="{ row }">
                {{ row.insutype | dictText("insutype") }}
              </template>
            </el-table-column>
            <el-table-column
              label="人员类别"
              prop="psn_type"
              align="center"
              width="100"
            >
              <template slot-scope="{ row }">
                {{ row.psn_type | dictText("psn_type") }}
              </template>
            </el-table-column>
            <el-table-column
              label="公务员标志"
              prop="cvlserv_flag"
              align="center"
            >
              <template slot-scope="{ row }">
                {{ row.cvlserv_flag | dictText("cvlserv_flag") }}
              </template>
            </el-table-column>
            <el-table-column
              label="参保地医保区划"
              prop="insuplc_admdvs"
              align="center"
              width="150"
            ></el-table-column>
            <el-table-column
              label="单位名称"
              prop="emp_name"
              align="center"
            ></el-table-column>
          </el-table>
          <div style="margin-top: 20px" v-if="result.baseinfo.psn_no">
            <selector-spinfo :med-code="medCode" :value.sync="entity.spinfo">
            </selector-spinfo>
          </div>
        </div>
        <div
          style="
            width: 25rem;
            border-left: 1px solid gainsboro;
            margin-left: 10px;
            padding-top: 10px;
          "
          v-if="showMdtrtinfo"
        >
          <selectorMdtrtinfo ref="mdtrtinfo"></selectorMdtrtinfo>
        </div>
      </div>
    </section>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">关 闭</el-button>
      <el-button
        type="primary"
        @click="handleSubmit"
        :disabled="!result.baseinfo"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import api from "@/common/api";
const medicareReadCard = () =>
  import(/* webpackChunkName: 'medicareReadCard' */ "./medicareReadCard");
const selectorSpinfo = () =>
  import(/* webpackChunkName: 'selectorSpinfo' */ "./selectorSpinfo");
const selectorMdtrtinfo = () =>
  import(/* webpackChunkName: 'selectorMdtrtinfo' */ "./selectorMdtrtinfo");

export default {
  name: "medicareDialog",
  components: {
    selectorSpinfo,
    medicareReadCard,
    selectorMdtrtinfo,
  },
  props: {
    visible: Boolean,
    patientId: Number,
    showMdtrtinfo: {
      type: Boolean,
      default: false,
    },
    onlyBaseinfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      medCode: this.$store.state.medCode,
      loading: false,
      items: [],
      entity: {
        baseinfo: null,
        insuinfo: null,
        spinfo: null,
      },
      result: {
        baseinfo: null,
        idetinfo: [],
        insuinfo: [],
      },
      selectionKey: null,
    };
  },
  methods: {
    open() {
      this.loading = false;
      this.entity = {};
      this.items = [];
      this.result = [];
      this.selectionKey = null;
    },
    receiveCardInfo(data) {
      console.log("读卡返回的数据", data);
      if (!data || !data.output.length) return;
      this.medCode = data.medCode;
      this.items = data.output;
      this.result = data.output[0];
      this.$set(
        this.entity,
        "baseinfo",
        this.$utils.clone(this.result.baseinfo)
      );
      this.$set(
        this.entity,
        "idetinfo",
        this.$utils.clone(this.result.idetinfo)
      );
      this.$set(this.entity, "readCard", this.$utils.clone(data.readCard));
      this.$set(this.entity, "med_code", data.medCode);
      this.$set(this.entity, "certno", this.result.baseinfo.certno); // 身份证20230628
      console.log(4400123, "this.entity=", this.entity);
      console.log("this.patientId: ", this.patientId);

      this.entity.header = data.header;
    },
    async handleSubmit() {
      if (!this.entity.insuinfo && !this.onlyBaseinfo) {
        this.$message.warning("请选择人员参保信息！");
        return;
      }
      if (this.$refs.mdtrtinfo) {
        const res = await this.$refs.mdtrtinfo.save().catch((err) => {
          return false;
        });
        if (!res) return;
        Object.assign(this.entity, res);
      }
      // this.$utils.log(this.entity);
      this.entity.header.insuplc_admdvs =
        this.result.insuinfo[this.selectionKey]?.insuplc_admdvs || ""; // 刷卡人的参保地医保区划
      console.log(666222, "ok回传数据=", this.entity);
      if (this.$refs?.mdtrtinfo?.entity) {
        this.$set(
          this.entity,
          "acct_used_flag",
          this.$refs.mdtrtinfo.entity?.acct_used_flag
        );
      }
      this.$emit("ok", this.entity);
      this.$emit("update:visible", false);
    },
    close() {
      // this.$message.warning('医保交易取消！');
      this.$emit("update:visible", false);
    },
    // 参保信息table双击选中行
    select(row) {
      this.$set(this.entity, "insuinfo", row);
      this.handleSubmit();
    },
    // 人员下拉选择
    handleChange(val) {
      if (val) {
        this.$set(this.entity, "baseinfo", this.$utils.clone(val.baseinfo));
        this.$set(this.entity, "idetinfo", this.$utils.clone(val.idetinfo));
        this.$set(this.entity, "insuinfo", null);
        this.$set(this.entity, "spinfo", null);
      }
    },
    selectionChange(currentRow) {
      // 刷卡更新患者表医保卡号、医保类型
      if (this.patientId) {
        api.getPatientById(this.patientId).then((res) => {
          if (
            res.name === this.result.baseinfo.psn_name &&
            res.idNo === this.result.baseinfo.certno
          ) {
            res.insuranceNo = this.result.baseinfo.psn_no;
            if (this.result.insuinfo && this.result.insuinfo.length) {
              res.insuranceType =
                this.result.insuinfo[this.selectionKey].insutype;
              res.insuplcAdmdvs =
                this.result.insuinfo[this.selectionKey].insuplc_admdvs;
            }
            console.log(res);

            api.savePatient(res);
          }
        });
      }

      this.$set(this.entity, "insuinfo", currentRow);
      this.result.insuinfo.map((item, index) => {
        if (JSON.stringify(item) === JSON.stringify(currentRow)) {
          this.selectionKey = index;
        }
      });
    },
  },
};
</script>

<style>
.el-dialog__body {
  padding: 0 20px 10px 20px !important;
}
.el-dialog__header {
  margin-bottom: 10px;
  text-align: center;
}
</style>
